<template>
  <div>
    <Dialog
      modal
      :visible="true"
      @hide="emit('close')"
      :closable="false"
      :style="{ display: 'flex', justifyContent: 'center' }"
      contentStyle="width: auto; max-width: 95vw; min-width: 400px;"
    >
      <component
        :is="strategyComponent"
        v-bind="strategyProps"
        @close="emit('close')"
        @openModalsuccess="emit('openModalsuccess', $event)"
      />
    </Dialog>
  </div>
</template>

<script setup>
import { computed } from "vue";

const props = defineProps({
  tipoEntidad: String,
  data: Object,
});

const emit = defineEmits(["close"]);

// Importar los formularios
import tipoEfecto from "@/components/forms/Parametrizacion/TipoEfecto.vue";
import Subcategoria from "@/components/forms/Parametrizacion/Subcategoria.vue";
import Modelo from "../forms/Parametrizacion/Modelo.vue";

const componentsMap = {
  tipoID: tipoEfecto,
  SubcategoriaID: Subcategoria,
  ModeloID: Modelo,
};

const propsMap = {
  tipoID: () => ({ tipoEfectoData: props.data }),
  SubcategoriaID: () => ({ subcategoriaData: props.data }),
  ModeloID: () => ({ modeloData: props.data }),
};

const strategyComponent = computed(() => componentsMap[props.tipoEntidad] || null);
const strategyProps = computed(() => propsMap[props.tipoEntidad]?.() || {});
</script>
